import React from 'react';
import PropTypes from 'prop-types';
import { HashLink } from 'react-router-hash-link';

const SidebarHashLink = props => {
  return (
    <HashLink to={`/#${props.containerId}`} className="sidebar-link" onClick={props.onClick} smooth>
      {props.name}
    </HashLink>
  );
};

SidebarHashLink.propTypes = {
  containerId: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default SidebarHashLink;
